import { Box, BoxProps } from "@mui/material";
import React from "react";

export const CustomBox: React.FC<BoxProps> = ({ children, sx, ...rest }) => {
  return (
    <Box
      {...rest}
      sx={{
        display: "flex",
        alignItems: "center",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
